import { FC, useMemo } from 'react';

import { trim } from 'lodash';
import { ConversationIcon } from 'ui/components/icon';
import { Conversation } from 'utils/types';
import { useDeleteConversation } from 'modules/account/copilot/hooks';
import useModal from 'ui/partials/Modal/useModal';
import { NavAction } from 'ui/components/nav';
import { TbDotsVertical } from 'react-icons/tb';
import { cn } from 'utils/helpers';

import DeleteItemModal from '../DeleteItemModal';

interface Props {
  conversation: Conversation;
  onSelectConversation: (c: Conversation) => void;
}

const HistoryItem: FC<Props> = ({ conversation, onSelectConversation }) => {
  const { showModal, hideModal } = useModal();
  const { mutate: deleteConversation, isLoading } = useDeleteConversation();
  const options = useMemo(
    () => [
      {
        text: 'Delete',
        key: 'del',
        onClick: () => {
          showModal({
            content: (
              <DeleteItemModal
                onClickDelete={() =>
                  deleteConversation(conversation._id, {
                    onSuccess: () => {
                      hideModal();
                    },
                  })
                }
                text="Conversation"
                isLoading={isLoading}
              />
            ),
          });
        },
      },
    ],
    [showModal, isLoading, deleteConversation, conversation._id, hideModal],
  );
  return (
    <div className="flex items-center gap-2.5 p-2.5 group justify-between w-full">
      <button
        onClick={(e) => {
          e.stopPropagation();
          onSelectConversation(conversation);
        }}
        className="flex items-center gap-2.5"
      >
        <ConversationIcon className="w-3 h-3 text-content shrink-0" />
        <p className="text-sm line-clamp-2 text-left">
          {trim(conversation.title, '"')}
        </p>
      </button>
      <NavAction
        className="hidden group-hover:block"
        label={
          <TbDotsVertical
            className={cn(
              'h-4 w-4',
              'text-secondary-dark hover:text-primary-base',
            )}
          />
        }
        options={options}
      />
    </div>
  );
};

export default HistoryItem;
